import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import qs from 'query-string';
import pick from 'lodash/pick';
import omit from 'lodash/omit';
import toMomentObject from 'react-dates/lib/utils/toMomentObject';
import toISODateString from 'react-dates/lib/utils/toISODateString';
import ListingPage from 'pages/ListingPage';
import { getQuery } from 'listing/listing.selectors';
import { getNumberOfMonthsInDatePicker } from 'website/website.selectors';
import { queryChange, fetchListingCalendar, fetchSingleListing, updateActiveListing } from 'listing/listing.actions';

function mapStateToProps(state, ownProps) {
  const id = ownProps.match.params.id;
  const { listings: { query, results, searchResults, activeListing } } = state;
  const listing = (activeListing && activeListing._id === id && activeListing) || results[id];
  const bookedDays = listing.calendar && listing.calendar.filter(day => day.status !== "available").map(day => toMomentObject(day.date));
  const similar = omit(pick(results, searchResults), id);
  return {
    pageTitle: state.website.title,
    startDate: toMomentObject(query.startDate),
    endDate: toMomentObject(query.endDate),
    guests: query.guests,
    listing,
    similar,
    query: getQuery(state),
    bookedDays,
    color: state.website.color,
    numberOfMonths: getNumberOfMonthsInDatePicker(state)
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onDateChange: ({ startDate, endDate }) => {
      const dates = {};
      if (startDate) dates.startDate = toISODateString(startDate);
      if (endDate) dates.endDate = toISODateString(endDate);
      dispatch(queryChange(dates));
      const params = { ...qs.parse(ownProps.location.search), ...dates };
      dispatch(push(`${ownProps.location.pathname}?${qs.stringify(params)}`));

      if (startDate && endDate) {
        dispatch(fetchSingleListing(ownProps.match.params.id, dates.startDate, dates.endDate));
      }
    },
    onGuestChange: guests => {
      const guestParam = { guests };
      dispatch(queryChange(guestParam));
      const params = { ...qs.parse(ownProps.location.search), ...guestParam };
      dispatch(push(`${ownProps.location.pathname}?${qs.stringify(params)}`))
    },
    fetchCalendar: (listingId, from, to) => dispatch(fetchListingCalendar(listingId, from, to)),
    updateActiveListing: listingId => dispatch(updateActiveListing(listingId))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ListingPage);




// WEBPACK FOOTER //
// ./src/containers/ListingPage.container.js